import { UserOutlined } from "@ant-design/icons"

const menu = [{ order: 1, isParent: false, title: "Kullanıcılar", icon: UserOutlined, to: "/admin/users" }]

export default menu
